import React from 'react';
import PropTypes from 'prop-types';
import { theme } from 'theme';
import makeStyles from '@mui/styles/makeStyles';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

const { white } = theme.palette.custom;

const useStyles = makeStyles(() => ({
  container: {
    'page-break-inside': 'avoid',
    marginLeft: -60,
    marginBottom: 25,
    top: 0,
    width: 'calc(100% + 120px)',
  },
  header: {
    margin: '15px 30px',
    padding: '35px 30px 15px',
    width: 'auto',
    borderBottom: '2px solid rgb(233, 233, 233)',
  },
  companyName: {
    fontSize: 21,
    fontWeight: 'bold',
  },
  imageWrapper: {
    backgroundColor: white,
    boxShadow: '0 1px 2px rgba(0,0,0,.16)',
    padding: '7px 5px 5px',
    display: 'flex',
  },
  textWrapper: {
    paddingRight: 8,
    marginLeft: 7,
    paddingTop: 11,
  },
  text: {
    fontSize: 10,
  },
  image: {
    height: 40,
    paddingRight: 8,
    borderRight: '1px solid rgb(233, 233, 233)',
  },
}));

const GenerateReportsHeaderSection = ({ companyName }) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="flex-end"
        className={classes.header}
      >
        <Typography color="textPrimary" component="p" className={classes.companyName}>
          {companyName}
        </Typography>
        <div className={classes.imageWrapper}>
          <img className={classes.image} src="images/scope-logo.jpg" alt="Scope Group Logotype" />
          <div className={classes.textWrapper}>
            <Typography color="primary" variant="body2" className={classes.text}>
              Scope
            </Typography>
            <Typography color="textPrimary" variant="body2" className={classes.text}>
              Group
            </Typography>
          </div>
        </div>
      </Grid>
    </div>
  );
};

GenerateReportsHeaderSection.propTypes = {
  companyName: PropTypes.string.isRequired,
};

export default GenerateReportsHeaderSection;
